module.exports = __webpack_public_path__ + "static/img/Group421.5ea9928.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/bind-device-v2/Group421.png
// module id = X56z
// module chunks = 1